module.exports = __webpack_public_path__ + "img/hdc_02.29a02f8f.png";